import {isAuthenticated} from "../common/server";
import {Navigate, useLocation} from "react-router-dom";

function RequireAuth({children}) {
    const location = useLocation();

    return isAuthenticated()? children : <Navigate to="/shop/login" replace state={{from: location}} />;
}

export default RequireAuth;